module.exports = __webpack_public_path__ + "static/img/select.4728a076.svg";